module.exports = __webpack_public_path__ + "img/1.a457b1d3.jpg";